'use strict';

module.exports = {
    AGENT_STATUS: 'manda.agent.status',
    JOBS_STARTING: 'manda.jobs.starting',
    JOBS_RUNNING: 'manda.jobs.running',
    JOBS_COMPLETE: 'manda.jobs.complete',
    JOBS_TRANSFER_STARTING: 'manda.jobs.transfer.starting',
    JOBS_TRANSFER_COMPLETE: 'manda.jobs.transfer.complete'
};